import React, {useState} from "react";
import {FormControlLabel, Switch, Tab, Tabs, Typography} from "@material-ui/core";
import Flex from "components/grid/Flex";
import Sidebar from "components/sidebar/Sidebar";
import SystemAdminPatientList from "scenes/patient/SystemAdminPatientList";
import {
    getStoredClinicalReportAnonymizationEnabled,
    isClinicalReportAnonymizationEnabled,
    saveClinicalReportAnonymizationEnabled,
} from "scenes/doctors-letter/ClinicalReportAnonymizationPreference";
import {
    useGetClinicalReportAnonymizationGlobalSettingQuery,
    useSaveClinicalReportAnonymizationGlobalSettingMutation,
} from "scenes/doctors-letter/DoctorsLetterApi";

const PATIENT_DUPLICATES_TAB = "PATIENT_DUPLICATES";
const CLINICAL_REPORT_SUMMARIZER_TAB = "CLINICAL_REPORT_SUMMARIZER";

const ClinicalReportSummarizerSetting = () => {
    const {
        data: isGlobalAnonymizationEnabled,
        isLoading: loadingGlobalAnonymizationSetting,
        isError: isGlobalAnonymizationSettingError,
    } = useGetClinicalReportAnonymizationGlobalSettingQuery();
    const [saveClinicalReportAnonymizationGlobalSetting, {isLoading: savingGlobalAnonymizationSetting}] =
        useSaveClinicalReportAnonymizationGlobalSettingMutation();
    const [storedAnonymizationEnabled, setStoredAnonymizationEnabled] = useState(getStoredClinicalReportAnonymizationEnabled);

    const onGlobalAnonymizationEnabledChange = (globalAnonymizationSwitchChangeEvent) => {
        saveClinicalReportAnonymizationGlobalSetting(globalAnonymizationSwitchChangeEvent.target.checked);
    };

    const onAnonymizationEnabledChange = (anonymizationSwitchChangeEvent) => {
        const isAnonymizationSwitchChecked = anonymizationSwitchChangeEvent.target.checked;
        saveClinicalReportAnonymizationEnabled(isAnonymizationSwitchChecked);
        setStoredAnonymizationEnabled(isAnonymizationSwitchChecked);
    };

    return (
        <Flex item container column style={{padding: 16}}>
            <FormControlLabel
                control={
                    <Switch
                        color={"primary"}
                        checked={isGlobalAnonymizationEnabled !== false}
                        disabled={loadingGlobalAnonymizationSetting || savingGlobalAnonymizationSetting || isGlobalAnonymizationSettingError}
                        onChange={onGlobalAnonymizationEnabledChange}
                    />
                }
                label={"Pseudonymise uploaded clinical reports for everyone"}
            />
            <Typography variant={"body2"} style={{marginBottom: 16}}>
                Applies to all users, except in browsers where the setting below has been changed.
            </Typography>
            <FormControlLabel
                control={
                    <Switch
                        color={"primary"}
                        checked={isClinicalReportAnonymizationEnabled(isGlobalAnonymizationEnabled, storedAnonymizationEnabled)}
                        onChange={onAnonymizationEnabledChange}
                    />
                }
                label={"Pseudonymise uploaded clinical reports in this browser"}
            />
            <Typography variant={"body2"}>
                When turned off, uploaded clinical reports are not sent for pseudonymisation and go to summarisation as
                they were uploaded. This setting applies to this browser only and overrides the setting for everyone.
            </Typography>
        </Flex>
    );
};

const AdminTool = () => {
    const [selectedAdminToolTab, setSelectedAdminToolTab] = useState(PATIENT_DUPLICATES_TAB);

    return (
        <>
            <Sidebar />
            <Flex item container column style={{marginLeft: 60}}>
                <Tabs
                    value={selectedAdminToolTab}
                    onChange={(adminToolTabChangeEvent, adminToolTab) => setSelectedAdminToolTab(adminToolTab)}
                    indicatorColor={"primary"}
                    textColor={"primary"}
                >
                    <Tab value={PATIENT_DUPLICATES_TAB} label={"Patient duplicates"} />
                    <Tab value={CLINICAL_REPORT_SUMMARIZER_TAB} label={"Clinical report summarizer"} />
                </Tabs>
                {selectedAdminToolTab === PATIENT_DUPLICATES_TAB && <SystemAdminPatientList />}
                {selectedAdminToolTab === CLINICAL_REPORT_SUMMARIZER_TAB && <ClinicalReportSummarizerSetting />}
            </Flex>
        </>
    );
};

export default AdminTool;
